<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoEdit }}</pre> -->
                 <!-- <pre>{{ infoCaract }}</pre> -->
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>{{ infoEdit[0].tipo_activo }}</h5>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoEdit[0].descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="text-center">
                    <b-col cols="12 mt-4">
                        <h5>{{ labels.caracteristica }}</h5>
                    </b-col>
                </b-row>
                <div id="contenedor">
                    <div v-if="infoCaract != 0">
                        <b-row class="" v-for="caracteristica in infoCaract" :key="caracteristica.id">
                            <b-col cols="2"></b-col>
                            <b-col cols="4" class="text-left">
                                <h5>{{caracteristica.caracteristica}}</h5>
                            </b-col>
                            <b-col cols="6" class="text-left">
                                <input type="text" v-model="caracteristica.descripcion" class="form-control" id="caracteristica">
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <b-row class="d-flex justify-content-center">
                    <md-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="addCaracteristica()">
                        <md-icon>add</md-icon>
                    </md-button>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="6" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3">
                        <md-button class="md-primary" @click="guardarTipoActivo">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteActivo" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo'
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica';
import InacticaItem from '../../utils/InacticaItem.vue'

const cantFilaCaract = []
const listCaracteristicas = []
let objList = {}
let cont = 0

export default {
    name:'Editar',
    props:['modalEditar','infoEdit','infoCaract'],
    components: {InacticaItem},
    data:() => ({
        codigo : "",
        descripcion : "",
        deleteActivo : false,
        idTipoActivo : null,
        listCaract : []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    caracteristica: "Caracteristicas",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar'
                }
            }else{
                return {
                    title: "Edit active type",
                    codigo : "Code",
                    descripcion : "Description",
                    caracteristica: "Characteristics",
                    save : "Sava",
                    close : "Close",
                    delete : 'Delete'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoActivo(){
            if(this.infoEdit[0].descripcion == ''){
                this.$toast.error('Campo pendiente por diligenciar')
            }else{

                if(cont >= 1){
                    //////////////////GUARDA NUEVA CARACTERISTICA//////////////////

                    if(document.getElementById('caracteristica'+0).value == ''){
                        this.$toast.error('Debe agregar la caracteristica.')
                        location. reload()
                        return
                    }
    
                    cantFilaCaract.forEach((e,ind) => {
                        console.log(e);

                        if(document.getElementById('caracteristica'+ind).value == ''){
                            return this.$toast.error('Debe agregar la caracteristica.')
                        }

                        objList = {
                            'codTipoActivo' : parseInt(this.infoEdit[0].tipo_activo,10),
                            'codCaracteristica' : parseInt(document.getElementById('caracteristica'+ind).value,10),
                            'caracteristica' : document.getElementById('valor'+ind).value,
                            'idUser' : this.$store.state.userId
                        }
                        listCaracteristicas.push(objList)
                    })
                    // console.log(listCaracteristicas);
    
                    TipoActivoCaracteristica.createTipoActivoCaract(listCaracteristicas)
                    .then((res) => {
                        if(res.status == 201){
                            this.$toast.success(res.data.message)
                            location. reload()
                        
                        }else if(res.status == 204){
                            this.$toast.error('Caracteristica ingresada ya existe.')
                            return
                        }
                    })
                    .catch((error) => error)
                    //////////////////FIN GUARDA NUEVA CARACTERISTICA//////////////////
                
                }else{

                    TipoActivoCaracteristica.updateTipoActivoCaractById(this.infoCaract)
                    .then((res) => {
                        if(res.status == 200){
                            this.$toast.success(res.data.message)
                            location. reload()
                        
                        }else if(res.status == 404){
                            this.$toast.error('Caracteristica no encontrada.')
                            return
                        }
                    })
                    .catch((error) => error)
                }

                let info = {
                    'idTipoActivo' : this.infoEdit[0].id,
                    'descripcion' : this.infoEdit[0].descripcion,
                    'idUser' : this.$store.state.userId
                }

                TipoActivo.updateActivoById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo activo ya existe.')
                    }
                })
                .catch((error) => error)
            }
        },
        cierraModalDelet(){
            this.deleteActivo = false
        },
        eliminaRegistro(){
            this.idTipoActivo = this.infoEdit[0].id
            this.deleteActivo = true
        },
        confirmInactivate(){
            // console.log(this.idTipoActivo);
            TipoActivo.deleteTipoActivo(this.idTipoActivo)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()
                
                }
            })
            .catch((error) => error)
        },
        addCaracteristica(){
            
            // Crear un nuevo div para la fila
            const nuevaFila = document.createElement('div');
            
            // Añadir clase para estilo
            nuevaFila.className = 'fila';
            
            // Crear la primera celda
            const celda1 = document.createElement('div');
            celda1.className = 'celda';
            // celda1.textContent = 'Celda 1'; // Contenido de la primera celda

            const input1 = document.createElement('input');
            input1.type = 'text'; // Tipo de input
            input1.id = 'caracteristica'+cont
            input1.className = 'form-control'
            input1.placeholder = 'Código'
            celda1.appendChild(input1); // Añadir el input a la primera celda
            
            // Crear la segunda celda
            const celda2 = document.createElement('div');
            celda2.className = 'celda';
            // celda2.textContent = 'Celda 2'; // Contenido de la segunda celda

            const input2 = document.createElement('input');
            input2.type = 'text'; // Tipo de input
            input2.id = 'valor'+cont
            input2.className = 'form-control'
            input2.placeholder = 'Valor'
            celda2.appendChild(input2); // Añadir el input a la segunda celda

            // Agregar las celdas a la fila
            nuevaFila.appendChild(celda1);
            nuevaFila.appendChild(celda2);
            
            // Agregar la nueva fila al contenedor
            document.getElementById('contenedor').appendChild(nuevaFila);
            cantFilaCaract.push(nuevaFila)
            cont = cont + 1
        }
    },
    watch:{
        /*modalEditar(valEst){
            // console.log(valEst);
            if(valEst){
                TipoActivoCaracteristica.getTipoActivoCaractByTipAct(this.infoEdit[0].tipo_activo)
                .then((res) => {
                    // console.log(res.data.tipActCar);
                    this.listCaract = res.data.tipActCar
                })
                .catch((error) => { console.log(error) })
            }
        }*/
    }
}
</script>

<style>

</style>